var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.propsHeader.key === 'statusName')?[_c('v-chip',{staticClass:"ma-2",style:('background-color: ' + _vm.getStatusColor(_vm.text))},[_c('span',[_vm._v(_vm._s(_vm.getText(_vm.text)))])])]:[_vm._v(" "+_vm._s(_vm.getText(_vm.text))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }